declare var swal: any;
import { Component, Input, OnInit, ViewChild} from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';
//import { Chart } from '';

//import { ChartOptions, ChartType, ChartDataSets, Label} from 'chart.js';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SaveCounsellingActivityRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanController, CounsellingPlanRequest, CounsellingActivityController, CounsellingActivityRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, SaveCounsellingPlanRequest, MisReportCategoriesController, MisReportCategoriesRequest } from '../../../../../.././../src/app/ncs/models/actor/actor';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
//import { NgbActivityMonitoringModal } from './activitymonitoringmodal/activitymonitoring.modal';
import { timeInterval } from 'rxjs/operators';
//import { NgbViewCounsellingPlanModal } from '../counsellingregistry/modal/viewcounsellingplan.modal';
//import { NgbCounsellingRegistryModal } from './modal/counsellingregistry.modal';
@Component({
  selector: 'mis',
  templateUrl: './mis.component.html',
  styleUrls: ['./mis.component.css']
})
export class MISComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() FormattedCode: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
  ScheduleDate: NgbDateStruct;
  //public ActorCode: number = 0;
  public isNew: boolean = false;
    public isEdit: boolean = false;
    public GraphDisplay: boolean = false;
    public AnalysisDisplay: boolean = false;
    public Analysissmall: boolean = false;
  public IsExpand: boolean = true;
  public isRequesting: boolean = false;
  public BillingGraph: boolean = false;
  public LineGraph: boolean = false;
  public PieGraph: boolean = false;
  public Row1: boolean = true;
    public Row2: boolean = false;
    public IsSelected: boolean = false;
    public Row3: boolean = false;
    public ReportType: string;
    public GraphData: boolean = false;
    public Row1samll: boolean = false;
    public GraphList: boolean = true;
    public SelectedFromDate: NgbDateStruct;
    public SelectedToDate: NgbDateStruct;
    public FromDate: Date;
  public ToDate: Date;
 
    TodayDate = new Date();
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;
  
  //@ViewChild('f') IdentitiesForm: NgForm;
  
 
  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  
    CurrentMisReportCategoriesController: MisReportCategoriesController[];
    CurrentMisReportCategoriesRequest: MisReportCategoriesRequest;

    LoadMisCategories() {
        this.CurrentMisReportCategoriesRequest = new MisReportCategoriesRequest();
        this.CurrentMisReportCategoriesRequest.ConditionalOperator = 10;
        this.CurrentMisReportCategoriesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetMisReportCategoriesController();
    }
    GetMisReportCategoriesController() {
        this.StartRefreshing();

       
        //alert(this.FormattedCode);
        this.actorservice.GetMisReportCategoriesController(this.CurrentMisReportCategoriesRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentMisReportCategoriesController = this.ApiResData.Result;
                    //this.pdata = this.CurrentFollicularScansBetweenDateController;
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();

                }
                else {
                   this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                      this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService,
    private loginservice: LoginService) { }
 
  ngOnInit() {
    
    //this.LoadPatients();
      //this.GetPatientInfoByFormattedCodeController();
      this.SelectedFacilityCode = AppData.Instance().SelectedBranchCode;
      this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
      this.SelectedToDate={ year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
      this.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));

      this.LoadMisCategories();
      this.ReportType = "xyz";
  }
  
 
  
  

    SelectedGarph: MisReportCategoriesController ;

    SelectedGraphName(objCategory: any) {
        var Graph: MisReportCategoriesController = objCategory;
        if (Graph != null) {
           // this.SelectedGarph = null;
            this.SelectedGarph = Graph;
            this.GraphDisplay = true;
            this.AnalysisDisplay = false;
          this.LoadNewDates();
        }

    }
    Analysis() {
        this.GraphDisplay = false;
        this.AnalysisDisplay = true;
        this.GraphData = false;
        this.Analysissmall = true;
        this.GraphList = false;
    }
    //Analysis2() {
    //    this.GraphData = false;
    //    this.Analysissmall = true;
    //}

  viewBillGraph() {
    
    this.BillingGraph = true;
    this.LineGraph = false;
    this.PieGraph = false;
  }
  viewLineGraph() {

    this.BillingGraph = false;
    this.LineGraph = true;
    this.PieGraph = false;
  }
  viewPieGraph() {

    this.BillingGraph = false;
    this.LineGraph = false;
    this.PieGraph = true;
  }
  viewRow1() {
    this.Row2 = false;
    this.Row3 = false;
    this.Row1 = true;
  }
  viewRow2() {
    this.Row1 = false;
    this.Row3 = false;
    this.Row2 = true;
  }
  viewRow3() {
    this.Row1 = false;
    this.Row2 = false;
    this.Row3 = true;
    }
    SelectedGarphsmall: MisReportCategoriesController;
    viewRow1Small(objCategory: any) {
        var Graphsmall: MisReportCategoriesController = objCategory;
        if (Graphsmall != null) {
            // this.SelectedGarph = null;
            this.SelectedGarphsmall = Graphsmall;
            this.GraphList = false;
            this.GraphData = true;
          this.Row1samll = true;
          this.LoadNewDates();
        }
        
        
    }
    BackTodashboard2() {
        this.GraphList = true;
        this.GraphData = false;
        this.Row1samll = false;
        this.Analysissmall = false;
    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
    dataChanged(newobj) {
       // alert(this.SelectedFromDate);
     //   this.LoadNewDates();
        
  }
  CanLoadReport: boolean = false;
    /// call this method on click event.. of 'GO' Button
  LoadNewDates() {
    this.CanLoadReport = false;
        this.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
       // alert(this.FromDate);
    this.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
    this.CanLoadReport = true;
   // alert('load report now..');
}
    DecrementDate() {
        //this.dateI = new Date();
        //var i = this.dateI.valueOf() + 86400000;
        //this.dateI = new Date(i);
        //this.SelectedFromDate = dateI;
        //var ind: number = 0;
        //this.diff = this.diff - 1;
        //alert(this.diff);
        var monthNo = this.SelectedFromDate.month
        var d: Date = new Date(
            this.SelectedFromDate.year,
            monthNo - 1,
            this.SelectedFromDate.day
        );
        //this.parserFormatter.parse(this.SelectedFromDate).;

        d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
        //    d.getFullYear
        //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

        //  this.SelectedFromDate = this.SelectedFromDate.
        this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
        //this._GetFollicularScansBetweenDateController();
        //ind++;

        this.LoadNewDates();
    }
    IncrementDate() {
        //this.dateI = new Date();
        //var i = this.dateI.valueOf() + 86400000;
        //this.dateI = new Date(i);
        //this.SelectedFromDate = dateI;
        //var ind: number = 0;
        //this.diff = this.diff - 1;
        //alert(this.diff);
        var monthNo = this.SelectedFromDate.month
        var d: Date = new Date(
            this.SelectedFromDate.year,
            monthNo - 1,
            this.SelectedFromDate.day
        );
        //this.parserFormatter.parse(this.SelectedFromDate).;

        d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
        //    d.getFullYear
        //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

        //  this.SelectedFromDate = this.SelectedFromDate.
        this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
       // this._GetFollicularScansBetweenDateController();
        //ind++;
        this.LoadNewDates();
    }
SelectedFacilityCode: number;
    SelectedFacilityName: string;
   
    Roleassign(event: any) {

        if (event != null) {


            this.SelectedFacilityName = event;
            //this.LoadDoctorsList(this.SelectedFacilityCode);
        }

    }

}

